import { IOnePageInfo } from "@/types/types";
import React, { useState, useEffect } from "react";
import { useSmartNavigate } from "@/hooks";
import { Spin } from "antd";
import { findMenuTreeNode } from "@/utils/menu";
import { getMenus, getLowcodePageInfo } from "@/services";
import { getEffectivePagePath } from "@/utils";
import { registerSmartPageHistory } from "../utils";
import RenderLowcodePage from "@/pages/render-lowcode-page";
import styles from "../index.module.css";

const FormEditPage = ({ onePageInfo }: { onePageInfo?: IOnePageInfo }) => {
  const navigate = useSmartNavigate(onePageInfo);
  // 获取有效的低码页面path, 优先从onePageInfo中取
  const path = onePageInfo?.innerPagePath
    ? onePageInfo.innerPagePath
    : getEffectivePagePath();
  const [pageId, setPageId] = useState("");
  const [detailSchema, setDetailSchema] = useState(null); // 表单编辑页的schema
  const [nodePermitList, setNodePermitList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [smartPageHistoryInstance, setSmartPageHistoryInstance] =
    useState(null);

  /**
   * path变化时说明发生了页面切换, 需要重新获取页面信息
   */
  useEffect(() => {
    const getFormEditPageSchema = async () => {
      const { menus } = await getMenus();
      const node = findMenuTreeNode(menus, path); // 找到这个path对应菜单项的详细信息
      if (node && node.pageId) {
        // 当前path是CREATE页面, DETAIL / UPDATE 不是实体页面, 都挂在这个菜单path下
        try {
          // 1. 取当前CREATE页面关联的页面信息
          const { relatedPageInfoList } = await getLowcodePageInfo(node.pageId);
          // 2. 找到UPDATE页id, TODO: 暂时保持现状, 取第一个, 后续需要考虑指定datasetId
          const updatePageId = relatedPageInfoList?.[0]?.pageInfo.find(
            ({ type }) => type === "UPDATE",
          )?.id;
          // 3. 根据 UPDATE id 取完整页面信息
          const pageInfo = await getLowcodePageInfo(updatePageId);
          // 4. 获取 schema
          const editCode = JSON.parse(pageInfo.code);
          // 5. setState
          setDetailSchema(editCode || null);
          setNodePermitList(pageInfo.nodePermitList || []);
          setPageId(`${updatePageId}`);
          // 6. 注册smartPageHistory方法供 lowcode render 使用
          const historyInstance = registerSmartPageHistory(
            {
              pageType: "UPDATE",
              relatedPageInfoList: pageInfo.relatedPageInfoList,
              onePageInfo,
            },
            navigate,
          );
          setSmartPageHistoryInstance(historyInstance);
        } catch (error) {
          console.warn("error", error);
        } finally {
          setLoading(false); // 取消 loading
        }
      }
    };
    getFormEditPageSchema();
  }, [path]);

  return (
    <Spin tip="Loading..." spinning={loading}>
      <div className={styles.lowcodePage}>
        <RenderLowcodePage
          key={pageId}
          schema={detailSchema}
          nodePermitList={nodePermitList}
          pageId={pageId}
          location={location}
          navigate={navigate}
          onePageInfo={onePageInfo}
          smartPageHistory={smartPageHistoryInstance}
        />
      </div>
    </Spin>
  );
};

export default FormEditPage;
